import React, { useContext, useEffect, useState } from 'react'
import { Container, Footer, InputContainer, Row, Title } from './styled'
import { Input } from '../../../../components/common/Input'
import { Button } from '../../../../components/common/Button'
import { Select } from '../../../../components/common/Select'
import { Circle } from '@phosphor-icons/react'
import api from '../../../../services/api'
import { Context } from '../../../../context/context_employee'
import { Modal } from '../../../../components/Modal'
import { CheckCircle } from '@phosphor-icons/react/dist/ssr'

interface UserData {
  id: string
  Employee: { type: '' }
  UserInfo: {
    name: string
    email: string
    phone: string
    avatar: string
    birthdate: string
    Address: {
      address: string
      zipcode: string
      burgh: string
      city: string
      state: string
      latitude: number
      longitude: number
    }[]
  }
}

export const EditUser = ({ data }) => {
  const { baseOptions, maskPhone } = useContext(Context)
  const [confirm, setConfirm] = useState(false)
  const [updated, setUpdated] = useState(false)
  const [updatePhoneError, setUpdatePhoneError] = useState(false);
  const [updateError, setUpdateError] = useState(false);
  const [confirmActive, setConfirmActive] = useState(false)
  const [confirmDelete, setConfirmDelete] = useState<boolean>(false)
  const [deleted, setDeleted] = useState<boolean>(false)

  const [formData, setFormData] = useState({
    id: data.id,
    Employee: {
      type: data.Employee[0].type,
      id_base: data.Employee[0].Base.id,
    },
    UserInfo: {
      name: data.UserInfo[0].name,
      phone: data.UserInfo[0].phone.startsWith('55')
        ? data.UserInfo[0].phone.substring(2)
        : data.UserInfo[0].phone,
      email: data.UserInfo[0].email,
    },
    active: data.active,
    role: data.role,
    login: data.login,
    password: data.password,
  })

  const handleChange = (e) => {
    const { name, value } = e.target

    setFormData((prevData) => ({
      ...prevData,
      UserInfo: {
        ...prevData.UserInfo,
        [name]: value,
      },
    }))
  }

  const handleTypeChange = (e) => {
    const value = e.target.value

    setFormData((prevData) => ({
      ...prevData,
      Employee: {
        ...prevData.Employee,
        type: value,
      },
    }))
  }

  const handleBaseChange = (e) => {
    const value = e.target.value

    setFormData((prevData) => ({
      ...prevData,
      Employee: {
        ...prevData.Employee,
        id_base: value,
      },
    }))
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    try {
      await api.put('/v1/dashboard/employees/update', formData)
      setConfirm((prev) => !prev)
      setUpdated((prev) => !prev)
    } catch (error) {
      console.error('Erro ao atualizar aasda:', error.response.data)
      setConfirm((prev) => !prev)
      if (error.response.data === 'User with this phone already exists') {
        setUpdatePhoneError((prev) => !prev)
      } else {
        setUpdateError((prev) => !prev)
      }
    }
  }

  const handleDelete = async (e) => {
    e.preventDefault()
    try {
      const res = await api.delete('/v1/app/security/user/delete', {
        data: { id: data.id },
      })

      console.log('result delete funcionario', res.data)
      setDeleted((prev) => !prev)
      setConfirmDelete((prev) => !prev)
    } catch (err) {
      console.error('Erro ao excluir usuário:', err)
    }
  }

  const handleActive = async (e) => {
    e.preventDefault()

    const formDataActive = {
      ...formData,
      active: true,
    }

    try {
      await api.put('/v1/dashboard/employees/update', formDataActive)
      setConfirmActive((prev) => !prev)
      setUpdated((prev) => !prev)
    } catch (error) {
      console.error('Erro ao atualizar aasda:', error.response.data)
      setConfirmActive((prev) => !prev)
      setUpdateError((prev) => !prev)
    }
  }

  if (!data) {
    return <p>Carregando...</p>
  }

  return (
    <Container
      onSubmit={(e) => {
        e.preventDefault()
        setConfirm((prev) => !prev)
      }}
    >
      <Row>
        <InputContainer>
          <Input.Root>
            <Input.Label title="Nome do usuário" htmlFor="" />
            <Input.Wrapper backgroundColor="">
              <Input.Content
                value={formData.UserInfo.name}
                name="name"
                id={data.id}
                onChange={handleChange}
                required
              />
            </Input.Wrapper>
          </Input.Root>
        </InputContainer>
        <InputContainer width="15rem">
          <Title>Status</Title>
          <Button.Root
            backgroundColor={
              data.SocketConnections.length > 0 ? '#665396' : '#D92F18'
            }
          >
            <Button.Content
              title={data.SocketConnections.length > 0 ? 'Online' : 'Offline'}
              color="#fff"
            />
          </Button.Root>
        </InputContainer>
      </Row>
      <Row>
        <InputContainer>
          <Select
            onchange={handleTypeChange}
            label={{
              title: 'Tipo de acesso',
              htmlFor: '',
              color: '',
              fontSize: '14px',
            }}
            data={[
              { id: 'EMPLOYEE', value: 'Funcionário' },
              { id: 'OUTPOST', value: 'Posto' },
            ]}
            currentOption={formData.Employee.type}
          />
        </InputContainer>
        <InputContainer>
          <Select
            label={{
              title: 'Função do usuário',
              htmlFor: '',
              color: '',
              fontSize: '14px',
            }}
            onchange={(e) => {
              setFormData?.((prev: any) => ({
                ...prev,
                role: e.target.value,
              }))
            }}
            data={[
              { id: 'ADMINISTRADOR', value: 'ADMINISTRADOR' },
              { id: 'SEGURANCA', value: 'SEGURANCA' },
            ]}
            backgroundcolor=""
            bordercolor=""
            currentOption={formData?.role}
            outlinecolor=""
          />
        </InputContainer>
      </Row>
      <Row>
        <InputContainer>
          <Select
            onchange={handleBaseChange}
            label={{
              title: 'Base responsável',
              htmlFor: '',
              color: '',
              fontSize: '14px',
            }}
            data={baseOptions || []}
            backgroundcolor=""
            bordercolor=""
            currentOption={formData.Employee.id_base}
            outlinecolor=""
          />
        </InputContainer>
        <InputContainer width="15rem">
          <Title>Respondeu o alerta?</Title>
          <Button.Root backgroundColor="">
            {data.Employee[0].AlwaysAlertMessages.length > 0 &&
              data.Employee[0].AlwaysAlertMessages[0].answered_at ? (
              <>
                <Button.Icon>
                  <Circle size={16} color="#00B53D" weight="fill" />
                </Button.Icon>
                <Button.Content title={'Respondido'} color="494949" />
              </>
            ) : (
              <>
                <Button.Icon>
                  <Circle size={16} color="#D92F18" weight="fill" />
                </Button.Icon>
                <Button.Content title={'Não respondido'} color="494949" />
              </>
            )}
          </Button.Root>
        </InputContainer>
      </Row>
      <Row>
        <InputContainer>
          <Input.Root>
            <Input.Label title="E-mail" htmlFor="" />
            <Input.Wrapper backgroundColor="">
              <Input.Content
                name="email"
                value={formData.UserInfo.email || ''}
                onChange={(e) => {
                  setFormData((prev: any) => ({
                    ...prev,
                    UserInfo: { ...prev.UserInfo, email: e.target.value },
                  }))
                }}
              />
            </Input.Wrapper>
          </Input.Root>
        </InputContainer>
      </Row>
      <Row>
        <InputContainer>
          <Input.Root>
            <Input.Label title="Telefone" htmlFor="" />
            <Input.Wrapper backgroundColor="">
              <Input.Content
                name="phone"
                value={maskPhone(formData.UserInfo.phone || '')}
                onChange={handleChange}
                placeholder="(XX) XXXXX-XXXX"
              />
            </Input.Wrapper>
          </Input.Root>
        </InputContainer>
        <InputContainer>
          <Input.Root>
            <Input.Label title="Média de avaliação" htmlFor="" />
            <Input.Wrapper backgroundColor="">
              <Input.Content disabled />
            </Input.Wrapper>
          </Input.Root>
        </InputContainer>
      </Row>

      <Title>Informação de acesso</Title>
      <hr />

      <Row>
        <InputContainer>
          <Input.Root>
            <Input.Label title="Usuário - login" htmlFor="" />
            <Input.Wrapper backgroundColor="">
              <Input.Content
                id=""
                value={formData.login}
                name={formData.login}
                onChange={(e) => {
                  setFormData?.((prev: any) => ({
                    ...prev,
                    login: e.target.value,
                  }))
                }}
              />
            </Input.Wrapper>
          </Input.Root>
        </InputContainer>
      </Row>
      {/* <Row>
        <InputContainer>
          <Input.Root>
            <Input.Label title="Senha de acesso" htmlFor="" />
            <Input.Wrapper backgroundColor="">
              <Input.Content
                type="password"
                value={formData.password}
                name={formData.password}
                onChange={(e) => {
                  setFormData?.((prev: any) => ({
                    ...prev,
                    password: e.target.value,
                  }))
                }}
              />
            </Input.Wrapper>
          </Input.Root>
        </InputContainer>
      </Row> */}

      {data.UserInfo[0].Vehicle.length > 0 && (
        <>
          <Title>Veículo cadastrado pelo usuário</Title>
          <hr />

          <Row>
            <InputContainer>
              <Input.Root>
                <Input.Label title="Veículo" htmlFor="" />
                <Input.Wrapper backgroundColor="">
                  <Input.Content
                    type="text"
                    disabled
                    placeholder={data.UserInfo[0].Vehicle[0].vehicle}
                  />
                </Input.Wrapper>
              </Input.Root>
            </InputContainer>
            <InputContainer>
              <Input.Root>
                <Input.Label title="Placa" htmlFor="" />
                <Input.Wrapper backgroundColor="">
                  <Input.Content
                    type="text"
                    disabled
                    placeholder={data.UserInfo[0].Vehicle[0].plate}
                  />
                </Input.Wrapper>
              </Input.Root>
            </InputContainer>
          </Row>
        </>
      )}

      <Footer>
        <Button.Root
          backgroundColor="#308EC6"
          // onClick={() => setConfirm((prev) => !prev)}
          type="submit"
        >
          <Button.Content title="Editar dados" />
        </Button.Root>
        {data.active ? (
          <Button.Root
            backgroundColor="#770A00"
            onClick={() => setConfirmDelete((prev) => !prev)}
            type="button"
          >
            <Button.Content title="Desativar acesso" />
          </Button.Root>
        ) : (
          <Button.Root
            backgroundColor="#256ba0"
            onClick={() => setConfirmActive((prev) => !prev)}
            type="button"
          >
            <Button.Content title="Ativar acesso" />
          </Button.Root>
        )}
      </Footer>

      <Modal.Root
        backgroundcolor="#fff"
        borderradius="6px"
        width="fit-content"
        height="fit-content"
        left="50%"
        top="50%"
        open={confirm}
        setIsOpenController={() => setConfirm((prev) => !prev)}
      >
        <Modal.Header onclick={() => setConfirm((prev) => !prev)} />
        <Modal.Content
          value="Você deseja realmente modificar?"
          subvalue="Ao clicar em salvar, você estará atualizando as informações do usuário."
        />
        <Modal.Footer>
          <Button.Root
            backgroundColor="#fff"
            border="1px solid #770A00"
            onClick={() => setConfirm((prev) => !prev)}
          >
            <Button.Content title="Não, cancelar" color="#770A00" />
          </Button.Root>
          <Button.Root backgroundColor="#00517D" onClick={handleSubmit}>
            <Button.Content title="Salvar" color="#fff" />
          </Button.Root>
        </Modal.Footer>
      </Modal.Root>

      <Modal.Root
        backgroundcolor="#fff"
        borderradius="6px"
        height="fit-content"
        width="25%"
        left="50%"
        top="50%"
        open={updated}
        setIsOpenController={() => location.reload()}
      >
        <Modal.Header onclick={() => setUpdated((prev) => !prev)} />
        <Modal.Icon icon={<CheckCircle size={60} color="#00517D" />} />
        <Modal.Content
          value="Dados atualizados!"
          subvalue="Ao acessar novamente as informações desse
          usuário, você verá as novas informações deste perfil."
        />
        <Modal.Footer>
          <Button.Root
            backgroundColor="#00517D"
            onClick={() => location.reload()}
          >
            <Button.Content title="Voltar para página" color="#fff" />
          </Button.Root>
        </Modal.Footer>
      </Modal.Root>
      {/* Modals Edit User ERROR*/}
      <Modal.Root
        backgroundcolor="#fff"
        borderradius="6px"
        height="fit-content"
        width="25%"
        left="50%"
        top="50%"
        open={updatePhoneError}
        setIsOpenController={() => location.reload()}
      >
        <Modal.Header onclick={() => setUpdatePhoneError((prev) => !prev)} />
        <Modal.Icon icon={<CheckCircle size={60} color="#00517D" />} />
        <Modal.Content
          value="Erro!"
          subvalue="Número de telefone já cadastrado por outro usuário."
        />
        <Modal.Footer>
          <Button.Root
            backgroundColor="#00517D"
            onClick={() => setUpdatePhoneError((prev) => !prev)}
          >
            <Button.Content title="Voltar para página" color="#fff" />
          </Button.Root>
        </Modal.Footer>
      </Modal.Root>

      <Modal.Root
        backgroundcolor="#fff"
        borderradius="6px"
        height="fit-content"
        width="25%"
        left="50%"
        top="50%"
        open={updateError}
        setIsOpenController={() => location.reload()}
      >
        <Modal.Header onclick={() => setUpdateError((prev) => !prev)} />
        <Modal.Icon icon={<CheckCircle size={60} color="#00517D" />} />
        <Modal.Content
          value="Erro!"
          subvalue="Ocorreu um problema ao processar sua solicitação. Tente novamente."
        />
        <Modal.Footer>
          <Button.Root
            backgroundColor="#00517D"
            onClick={() => setUpdateError((prev) => !prev)}
          >
            <Button.Content title="Voltar para página" color="#fff" />
          </Button.Root>
        </Modal.Footer>
      </Modal.Root>
      {/* modals delete user */}

      <Modal.Root
        backgroundcolor="#fff"
        borderradius="6px"
        width="fit-content"
        height="fit-content"
        left="50%"
        top="50%"
        open={confirmDelete}
        setIsOpenController={() => setConfirmDelete((prev) => !prev)}
      >
        <Modal.Header onclick={() => setConfirmDelete((prev) => !prev)} />
        <Modal.Content
          value="Você deseja realmente excluir?"
          subvalue="Ao clicar em sim, você estará excluindo as informações do usuário."
        />
        <Modal.Footer>
          <Button.Root
            backgroundColor="#fff"
            border="1px solid #770A00"
            onClick={() => setConfirmDelete((prev) => !prev)}
          >
            <Button.Content title="Não, cancelar" color="#770A00" />
          </Button.Root>
          <Button.Root backgroundColor="#770A00" onClick={handleDelete}>
            <Button.Content title="Salvar" color="#fff" />
          </Button.Root>
        </Modal.Footer>
      </Modal.Root>

      {/* modals active user */}
      <Modal.Root
        backgroundcolor="#fff"
        borderradius="6px"
        height="fit-content"
        width="25%"
        left="50%"
        top="50%"
        open={confirmActive}
        setIsOpenController={() => setConfirmActive((prev) => !prev)}
      >
        <Modal.Header onclick={() => setConfirmActive((prev) => !prev)} />
        <Modal.Content
          value="Você deseja realmente ativar o acesso?"
          subvalue="Ao clicar em sim, você estará ativando o acesso do usuário."
        />
        <Modal.Footer>
          <Button.Root
            backgroundColor="#fff"
            border="1px solid #308EC6"
            onClick={() => setConfirmActive((prev) => !prev)}
          >
            <Button.Content title="Não, cancelar" color="#308EC6" />
          </Button.Root>
          <Button.Root backgroundColor="#308EC6" onClick={handleActive}>
            <Button.Content title="Ativar acesso" color="#fff" />
          </Button.Root>
        </Modal.Footer>
      </Modal.Root>

      <Modal.Root
        backgroundcolor="#fff"
        borderradius="6px"
        height="fit-content"
        width="25%"
        left="50%"
        top="50%"
        open={deleted}
        setIsOpenController={() => location.reload()}
      >
        <Modal.Header onclick={() => setDeleted((prev) => !prev)} />
        <Modal.Icon icon={<CheckCircle size={60} color="#770A00" />} />
        <Modal.Content
          value="Usuário excluído!"
          subvalue="Ao acessar novamente as informações desse
          usuário, você verá as novas informações deste perfil."
        />
        <Modal.Footer>
          <Button.Root
            backgroundColor="#770A00"
            onClick={() => location.reload()}
          >
            <Button.Content title="Voltar para página" color="#fff" />
          </Button.Root>
        </Modal.Footer>
      </Modal.Root>
      
    </Container>
  )
}
